import React from 'react';

import ResetPassword from "@/modules/user/components/ResetPassword/ResetPassword";

const ResetPasswordPage = () => (
  <ResetPassword />
);

export default ResetPasswordPage;
